import { InstitutionalTextPageProps } from "../components/InstitutionalTextPage";

export const HOUSING_PROGRAM_INFO_PAGE: InstitutionalTextPageProps = {
  path: "/his-hmp",
  title: "HIS e HMP — Enquadramento habitacional",
  description:
    "Guia de HIS-1, HIS-2 e HMP em São Paulo: renda familiar, limite de aluguel, locação, curta temporada e prazo de 10 anos, com base na legislação municipal de 2026.",
  lastUpdated: "setembro de 2026",
  notice:
    "Conteúdo baseado na legislação municipal de São Paulo vigente em 2026, inclusive o Decreto Municipal nº 64.895/2026. O enquadramento definitivo depende da unidade e da documentação exigida.",
};
